import Api from "./Api";

const Login = (data) => {
    return Api().post("/users/login", data)
}

const ConfirmEmail = (email) => {
    return Api().post("/users/forgot-password", email)
}

const ResetPassword = (resetPasswordToken, password) => {
    return Api().post(`/users/reset-password/${resetPasswordToken}`, password)
}

export { Login, ConfirmEmail, ResetPassword }